// Pages with their own search box listen for this so the header search button
// (and keyboard shortcuts) can focus it instead of opening the site-wide search.
export const FOCUS_PAGE_SEARCH_EVENT = 'aegyo:focus-page-search';

// Routes whose page search replaces the header search
export const PAGES_WITH_OWN_SEARCH = ['/photoshoots'];

export const focusPageSearch = () => {
    window.dispatchEvent(new CustomEvent(FOCUS_PAGE_SEARCH_EVENT));
};
